import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class HeaderService {

    endPointHeaderCompleted: string = environment.apiGatewayUrl + environment.endPointSufix + "/header";

    constructor(private http: HttpClient) {}

    getVersionApp(): Observable<string> {
        return this.http.get(`${this.endPointHeaderCompleted}/versionApp`, { responseType: 'text' });
    }
}